<script lang="ts">
	import { menu } from '@tools/Menu.svelte';
	import LargeMenuBlock from './LargeMenuBlock.svelte';
	import MenuColumns from './MenuColumns.svelte';
	import type { GlobalSettingsType } from '$lib/queries/GlobalSettingsQuery';
	import { Breakpoints } from '@tools';
	import { menuContentInOut } from '$lib/animations/MenuTransitions';
	import ChevronRight from '@icons/ChevronRight.svelte';

	let {
		data
	}: {
		data: GlobalSettingsType['menus'][0];
	} = $props();
</script>

{#if menu.current === data.id}
	<section>
		{#if !Breakpoints.md}
			<button
				onclick={() => menu.clickMobile()}
				in:menuContentInOut|global
				out:menuContentInOut|global
			>
				<div class="button:pill no-icon">
					<ChevronRight />
					<span>{data.title}</span>
				</div>
			</button>
		{/if}

		<MenuColumns data={data.columns} />

		{#if Breakpoints.md}
			<div class="blocks">
				{#each data.blocks as block, i}
					<LargeMenuBlock data={block} index={i} />
				{/each}
			</div>
		{/if}
	</section>
{/if}

<style lang="scss">
	section {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}

	.blocks {
		flex: 0 0 0;
		align-items: stretch;
		display: flex;
	}

	.button\:pill {
		background-color: $colorNavBackground;
		color: $colorNavForeground;

		&::selection {
			color: $colorBackground;
			background: $colorForeground;
		}

		:global(svg) {
			transform: rotate(180deg);
			height: 0.6em;
		}
	}

	button {
		padding: $gap6 var(--gutter);

		&:hover .button\:pill {
			background-color: $colorNavBackground;
			color: $colorNavForeground;
		}
	}
</style>
